import React from 'react';
import { Col, LinkButton, Row } from '@visalex/core';

import { useTranslation } from 'next-i18next';

import styles from './Application.module.scss';

const prefix = 'technology';

const Application = () => {
  const { t } = useTranslation();

  return (
    <Row className={styles.technology__application}>
      <div className={styles.technology__application_background}>
        <Col lg={6} md={4} xs={12}>
          <h3 className={styles.technology__application_title}>{t(`${prefix}.application.title`)}</h3>
          <div className="d-flex justify-content-between">
            <Row className="mx-n3">
              <Col xs={6} lg={6} md={12} className="mt-3">
                <LinkButton
                  href="https://apps.apple.com/ru/app/visalex-uscis-case-tracker/id1569955890"
                  target="_blank"
                  className={styles.technology__application_image}
                >
                  <img src="/images/technology/app_store.png" alt={t(`${prefix}.application.imageAlt.app-store`)} />
                </LinkButton>
              </Col>
              <Col xs={6} lg={6} md={12} className="mt-3">
                <LinkButton
                  href="https://play.google.com/store/apps/details?id=com.visalex.tracker"
                  target="_blank"
                  className={styles.technology__application_image}
                >
                  <img
                    src="/images/technology/google_market.png"
                    alt={t(`${prefix}.application.imageAlt.play-market`)}
                  />
                </LinkButton>
              </Col>
            </Row>
          </div>
        </Col>

        <Col lg={4} md={7} xs={12} className="ml-auto position-relative">
          <div className={styles.technology__application_mobile}>
            <img src="/images/technology/mobile.png" alt={t(`${prefix}.application.imageAlt.mobile`)} />
          </div>
        </Col>
      </div>
    </Row>
  );
};

export default Application;
